/** @param {(key: string) => string} tk */
export function getReferenceFields(tk) {
  return [
    {
      name: "title_ar",
      label: tk("fields.titleAr"),
      type: "text",
      required: true,
    },
    {
      name: "title_en",
      label: tk("fields.titleEn"),
      type: "text",
      required: true,
    },
    {
      name: "description_ar",
      label: tk("fields.descriptionAr"),
      type: "textarea",
      rows: 5,
    },
    {
      name: "description_en",
      label: tk("fields.descriptionEn"),
      type: "textarea",
      rows: 5,
    },
    {
      name: "image",
      label: tk("fields.image"),
      type: "file",
      maxFileMB: 2,
      hint: tk("hints.image"),
    },
  ];
}
